import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-partners-slider',
  templateUrl: './partners-slider.component.html',
  styleUrls: ['./partners-slider.component.scss']
})
export class PartnersSliderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
